import * as types from '../../constants/actionTypes';

export default function userAccountReducer(state = {}, action) {
    switch (action.type) {
        case types.USER_ACCOUNT_LOGIN_REQUEST:
            return {
                // loggingIn: true,
                user: action.username
            };
        case types.USER_ACCOUNT_LOGIN_SUCCESS:
            return {
                username: action.response.username,
            };
        case types.USER_ACCOUNT_LOGIN_FAILURE:
            return {
                user:''
            };
        case types.USER_ACCOUNT_LOGOUT:
            return {
            };
        default:
            return state;
    }
}